import React from 'react';
import { Box, Typography } from '@mui/material';
import zeplinColor from 'theme/Color';

type CategoryItem = {
  icon: string;
  label: string;
  percentage: number;
};

type CategoryListProps = {
  title: string;
  items: CategoryItem[];
  onViewAll?: () => void;
  maxHeight?: string;
};

const CategoryList = ({ title, items, onViewAll, maxHeight = '400px' }: CategoryListProps) => {
  return (
    <Box
      sx={{
        borderRadius: '14px',
        padding: { xs: '12px 16px', xl: '16px' },
        border: `1px solid ${zeplinColor.Neutral5}`,
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        flex: 1,
      }}
    >
      {/* Header */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant='responsiveHeading3'>{title}</Typography>
        {onViewAll && (
          <Typography
            variant='responsiveButtonSmall'
            color={zeplinColor.Brand1}
            sx={{ cursor: 'pointer' }}
            onClick={onViewAll}
          >
            View All
          </Typography>
        )}
      </Box>

      {/* Scrollable List */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
          maxHeight: maxHeight,
          overflowY: 'auto',
          '&::-webkit-scrollbar': {
            width: '6px',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: zeplinColor.Neutral5,
            borderRadius: '3px',
          },
        }}
      >
        {items?.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '8px',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',

                justifyContent: 'center',
              }}
            >
              {item?.icon ? (
                <img
                  src={item?.icon}
                  alt={item?.label}
                  width='32px'
                  height='32px'
                  style={{ borderRadius: '50%' }}
                />
              ) : (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    flex: 1,
                    borderRadius: '100px',

                    justifyContent: 'center',
                    width: '32px',
                    height: '32px',
                    backgroundColor: item?.icon ? 'transparent' : zeplinColor.Brand1,
                  }}
                >
                  <Typography variant='label1' color={zeplinColor.Neutral1}>
                    {item?.label
                      ?.split(' ')
                      .map((value: any, index: number) =>
                        item?.label && (index === 0 || index === item?.label?.split(' ').length - 1)
                          ? value[0]
                          : '',
                      )}
                  </Typography>
                </Box>
              )}
              <Typography variant='responsiveBody3'>{item?.label}</Typography>
            </Box>
            <Typography
              variant='responsiveBody3'
              sx={{ color: zeplinColor.BasicBlack, fontWeight: 500 }}
            >
              {item?.percentage}%
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default CategoryList;
